import { Button, TableColumnsType } from 'antd';
import { FunctionaryInfo } from '../../../../shared/VolunteerApplicationServiceTypes';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

interface ProposerReassignTableColumnsProps {
	onSubmitClick: (functionaryId: number) => void;
}

export const ProposerReassignTableListColumns = ({
	onSubmitClick,
}: ProposerReassignTableColumnsProps): TableColumnsType<FunctionaryInfo> => {
	const handleReassignProposerClick = useCallback(
		(proposer: FunctionaryInfo) => {
			onSubmitClick(proposer.id as number);
		},
		[onSubmitClick]
	);

	const { t } = useTranslation();
	return [
		{
			title: t('fullName'),
			dataIndex: 'printName',
			key: 'printName',
			className:
				'max-w-[400px] border-r-0 whitespace-nowrap md:whitespace-normal break-words',
		},
		{
			title: t('gender'),
			dataIndex: 'gender',
			key: 'gender',
			render: (__, record, index) => (
				<span key={index}>
					<span className="ml-2">
						{record?.gender
							? record.gender.charAt(0).toUpperCase() +
							  record.gender.slice(1).toLowerCase()
							: ''}
					</span>
				</span>
			),
		},
		{
			title: t('SRCMID'),
			dataIndex: 'srcmId',
			key: 'srcmId',
			className: 'whitespace-nowrap',
		},
		{
			title: t('currentlyAssigned'),
			dataIndex: 'applicationCount',
			key: 'applicationCount',
			className:
				'max-w-[400px] border-r-0 whitespace-nowrap md:whitespace-normal break-words',
			render: (__, record) => (
				<span>{record.applicationCount ? record.applicationCount : '0'}</span>
			),
		},
		{
			title: t('interviewCompleted'),
			dataIndex: 'interviewCount',
			key: 'interviewCount',
			className:
				'max-w-[400px] border-r-0 whitespace-nowrap md:whitespace-normal break-words',
			render: (__, record) => (
				<span>{record.interviewCount ? record.interviewCount : '0'}</span>
			),
		},
		{
			title: t('action'),
			key: 'operation',
			fixed: 'right',
			width: 150,
			render: (__, record) => (
				<Button
					className={`hidden sm:block font-sans font-bold text-sm border border-solid mt-0.5 text-primary-blue border-primary-blue w-auto`}
					variant="outlined"
					onClick={() => handleReassignProposerClick(record)}
				>
					{t('reAssign')}
				</Button>
			),
		},
	];
};
